export default __webpack_public_path__ + "static/media/noa-44.d434009c.jpg";